import {
  STORE_CLASS_DIAGNOSTIC_REQUEST,
  STORE_CLASS_DIAGNOSTIC_SUCCESS,
  STORE_CLASS_DIAGNOSTIC_ERROR,
  LIST_CLASS_DIAGNOSTICS_REQUEST,
  LIST_CLASS_DIAGNOSTICS_SUCCESS,
  LIST_CLASS_DIAGNOSTICS_ERROR,
  GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST,
  GET_CLASS_DIAGNOSTIC_DETAIL_SUCCESS,
  GET_CLASS_DIAGNOSTIC_DETAIL_ERROR,
  DELETE_CLASS_DIAGNOSTIC_REQUEST,
  DELETE_CLASS_DIAGNOSTIC_SUCCESS,
  DELETE_CLASS_DIAGNOSTIC_ERROR,
  RESET_STATE_ALL_APPLICATION,
  RESET_STATE_REDUX,
} from '../actions';

const INIT_STATE = {
  currentClassDiagnosticsList: null,
  currentClassDiagnosticDetail: null,
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return { ...state, error: '', success: '' };

    case STORE_CLASS_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case STORE_CLASS_DIAGNOSTIC_SUCCESS:
      return { ...state, loading: false, success: action.payload, error: '' };
    case STORE_CLASS_DIAGNOSTIC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };

    case LIST_CLASS_DIAGNOSTICS_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_CLASS_DIAGNOSTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentClassDiagnosticsList: action.payload,
        error: '',
      };
    case LIST_CLASS_DIAGNOSTICS_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST:
      return { ...state, loading: true, error: '' };
    case GET_CLASS_DIAGNOSTIC_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentClassDiagnosticDetail: action.payload,
        error: '',
      };
    case GET_CLASS_DIAGNOSTIC_DETAIL_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case DELETE_CLASS_DIAGNOSTIC_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case DELETE_CLASS_DIAGNOSTIC_SUCCESS: {
      const filtered = (state.currentClassDiagnosticsList ?? []).filter(
        (item) => item.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        currentClassDiagnosticsList: filtered,
        success: { deleted: true },
        error: '',
      };
    }
    case DELETE_CLASS_DIAGNOSTIC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };

    default:
      return { ...state };
  }
};
